import BasePostGrid from "@PegasusCore/pegasus-one-post-grid/src/script";

class PostGrid extends BasePostGrid {
    search = '';
    preview = false;

    constructor(preview) {
        super();
        this.preview = preview;
    }

    init() {
        super.init();

        this.ignoreFilters();

        if (this.preview) {
            return;
        }
        if (Object.values(this.currentFilters).length) {
            this.getAllPostGrids().forEach((container) => {
                container.remove();
            });
        }
    }

    ignoreFilters() {
        Object.keys(this.currentFilters).forEach((key) => {
            if (!key.startsWith("filter-")) {
                delete this.currentFilters[key];
            }
        });
    }

    fetchContent(href = null) {
        const postGrid = this.postGrid.querySelector('[data-pegasus-filterable]');
        const elements = ['data-pegasus-filterable="' + postGrid.dataset.pegasusFilterable + '"'];
        let currentUrl = '';

        if (!Object.keys(this.currentFilters).length) {
            if (href) {
                currentUrl = href;
            } else {
                window.location.href = window.location.protocol + '//' + window.location.hostname + window.location.pathname;
                return;
            }
        } else {
            currentUrl = this.buildUrl();
        }

        if (href) {
            currentUrl = href;
        }

        if (!this.isLoading) {
            this.isLoading = true;

            pegasus.ajaxContent(currentUrl, elements, {}, () => {
                this.isLoading = false;
                history.pushState(JSON.stringify(this.currentFilters), '', currentUrl);

                if (typeof window.modal !== "undefined") {
                    window.modal.init();
                }

                if (this.preview) {
                    return;
                }

                if (Object.values(this.currentFilters).length) {
                    this.getAllPostGrids().forEach((container) => {
                        container.remove();
                    });
                }
            });
        }
    }

    fetchPage(href = null) {
        const postGrid = this.$root.querySelector('[data-pegasus-filterable]');
        const elements = ['data-pegasus-filterable="' + postGrid.dataset.pegasusFilterable + '"'];

        if (!this.isLoading) {
            this.isLoading = true;

            pegasus.ajaxContent(href, elements, {}, () => {
                this.isLoading = false;
                history.pushState('', '', href);

                if (typeof window.modal !== "undefined") {
                    window.modal.init();
                }
            });
        }
    }

    getAllPostGrids() {
        const postGrids = document.querySelectorAll(
            "[data-pegasus-filterable]"
        );

        let postGridContainers = [];
        postGrids.forEach((postGrid) => {
            const postGridContainer = postGrid.closest(".Post__Grid");
            if (
                postGridContainer &&
                postGridContainer.classList.contains("has-filters")
            ) {
                return;
            }
            const container = postGrid.closest(".Pegasus__Container");
            if (!container) {
                return;
            }

            postGridContainers.push(container);
        });
        return postGridContainers;
    }

    getSelectedFilterText(filter) {
        const filterResults = this.currentFilters[`filter-t-${filter}`];
        let filtersArray = [];
        if (filterResults) {
            filtersArray = filterResults.split(",");
        }

        const escapeHtml = (unsafe) => {
            return unsafe
                .replaceAll("&", "&amp;")
                .replaceAll("<", "&lt;")
                .replaceAll(">", "&gt;")
                .replaceAll('"', "&quot;")
                .replaceAll("'", "&#039;");
        };

        if (filtersArray.length === 1) {
            let sector = filtersArray[0];
            sector = escapeHtml(sector);
            const text = this.$root.querySelector(`#${sector}`).textContent;
            return text;
        }

        return "Multiple";
    }

    /**
     * buildUrl
     * 
     * Description: Build the URL to request from based on the current filters.
     * 
     * @return void
     */
    buildUrl(){
        // Set the URL to the current page.
        let url = window.location.protocol + '//' + window.location.hostname + window.location.pathname;
        // remove any part of the path that matches /page/1
        url = url.replace(/\/page\/\d+/g, '');
        url += '?';
        let i = 1

        for (const [key, value] of Object.entries(this.currentFilters)) {
            url += `${key}=${value}`
            if(i < Object.keys(this.currentFilters).length){
                url+='&'
            }
            i++
        }

        return url;
    }
}

document.addEventListener("alpine:init", () => {
    Alpine.data("postGrid", (preview) => new PostGrid(preview));
});
